import { render } from "./FloatingAiButton.vue?vue&type=template&id=5d9294f1&scoped=true"
import script from "./FloatingAiButton.vue?vue&type=script&lang=js"
export * from "./FloatingAiButton.vue?vue&type=script&lang=js"

import "./FloatingAiButton.vue?vue&type=style&index=0&id=5d9294f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9294f1"]])

export default __exports__